/**
 * Exposes methods for converting objects using non-camel-casing into camelCasing.
 */
export class CaseConvert {
    private static toCamel(s: string): string {
      const camelCase = s.replace(/([_][a-z])/ig, ($1) => {
        return $1.toUpperCase()
          .replace('_', '');
      });

      const lowerCamelCase = camelCase.substr(0, 1).toLowerCase() + camelCase.substr(1);
      return lowerCamelCase;
    }

    private static isArray(a: any): boolean {
      return Array.isArray(a);
    }

    private static isObject(o: any): boolean {
      return o === Object(o) && !CaseConvert.isArray(o) && typeof o !== 'function' && !(o instanceof Date);
    }

    /**
     * Converts all keys/property names in the given object into camelCasing.
     */
    public static keysToCamel(o: any): any {
      if (CaseConvert.isObject(o)) {
        const n = {};

        Object.keys(o)
          .forEach((k) => {
            n[CaseConvert.toCamel(k)] = CaseConvert.keysToCamel(o[k]);
          });

        return n;
      } else if (CaseConvert.isArray(o)) {
        return o.map((i) => {
          return CaseConvert.keysToCamel(i);
        });
      }

      return o;
    }
  }
